import { render } from "./ProductHomePage.vue?vue&type=template&id=6a8d2ce1&scoped=true"
import script from "./ProductHomePage.vue?vue&type=script&lang=js"
export * from "./ProductHomePage.vue?vue&type=script&lang=js"

import "./ProductHomePage.vue?vue&type=style&index=0&id=6a8d2ce1&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8d2ce1"]])

export default __exports__